import enhanceAxios from "./enhanceAxios";
import validateParams from "./server/validation";
import uuid from "uuid/v4";
import axios from "axios";
const { CancelToken, isCancel } = axios;

const SUPPORTED_HTTP_METHODS = ["get", "post", "delete", "patch"];
const ASOS_CORRELATION_HEADER = "asos-cid";
const ASOS_SESSION_CORRELATION_HEADER = "asos-sid";
const ASOS_CLIENT_NAME_HEADER = "asos-c-name";
const ASOS_CLIENT_VERSION_HEADER = "asos-c-ver";
const ASOS_CLIENT_PLATFORM_HEADER = "asos-c-plat";
const DEFAULT_PLATFORM = "web";

const configureRequest = ({
  defaultTimeout,
  retries = 0,
  logger,
  serverRequestLogger,
  retryDelay,
  client,
  getSid
}) => {
  if (SERVER) {
    validateParams({ logger, client });
  }
  const { name, version, platform = DEFAULT_PLATFORM } = client;
  const axiosInstance = enhanceAxios({
    retries,
    logger,
    serverRequestLogger,
    retryDelay
  });

  const addStandardHeaders = headers => {
    if (!SERVER) {
      if (getSid && typeof getSid === "function") {
        headers[ASOS_SESSION_CORRELATION_HEADER] = getSid();
      }
    }
    headers[ASOS_CORRELATION_HEADER] = uuid();
    headers[ASOS_CLIENT_PLATFORM_HEADER] = platform;
    headers[ASOS_CLIENT_NAME_HEADER] = name;
    headers[ASOS_CLIENT_VERSION_HEADER] = version;
  };

  const request = method => ({
    url,
    uuid: serverUuid,
    params,
    body,
    headers = {},
    timeout = defaultTimeout,
    additionalLoggingParams = {},
    cancelTokenExecutor
  }) => {
    addStandardHeaders(headers);

    return axiosInstance({
      method,
      headers,
      url,
      params,
      data: body ? JSON.stringify(body) : undefined,
      timeout,
      asosConfig: { ...additionalLoggingParams, serverUuid },
      cancelToken: cancelTokenExecutor
        ? new CancelToken(cancelTokenExecutor)
        : undefined
    });
  };

  return SUPPORTED_HTTP_METHODS.reduce((methods, method) => {
    methods[method] = request(method);
    return methods;
  }, {});
};

const isCancelled = isCancel;

export { configureRequest, isCancelled };
